module.exports = __webpack_public_path__ + "lg.svg?34063911473a4caa0f0fd4ca3c897e25";